import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import useGetLanguages from 'api/useGetLanguages';
import PromatLogo from 'assets/promat-logo.png';
import LanguageSelect from 'features/language-select';
import { DEFAULT_LANGUAGE, DEFAULT_TRANSLATION_MARKET, ROUTES } from 'shared/constants';
import useLocalStorage from 'shared/hooks/useLocalStorage';
import { SESSION_STORAGE_KEYS } from 'shared/sessionStorageUtils';
import {
  CountryText,
  HeaderContent,
  SelectWrapper,
  StyledHeader,
  StyledImg,
  StyledLink,
} from './styles';
import { getLocaleString } from 'shared/utils/getLocaleString';

const AppBar = () => {
  const { t } = useTranslation();
  const { languages } = useGetLanguages();
  const currentPage = useLocation();
  const { pathname } = currentPage;
  const { getValueFromLocalStorage } = useLocalStorage();

  const selectedLanguage = getValueFromLocalStorage(
    SESSION_STORAGE_KEYS.language
  )?.value || DEFAULT_LANGUAGE;

  const selectedCountry = getValueFromLocalStorage(
    SESSION_STORAGE_KEYS.country
  );

  const selectedCountryCode = selectedCountry?.code || DEFAULT_TRANSLATION_MARKET;
  const selectedLanguageAndMarket = getLocaleString(selectedLanguage, selectedCountryCode);

  return (
    <StyledHeader>
      <HeaderContent>
        <StyledLink to={selectedCountry ? ROUTES.home : ROUTES.countrySelect}>
          <StyledImg src={PromatLogo} alt="Promat logo" />
        </StyledLink>
        {languages && selectedLanguageAndMarket && (
          <SelectWrapper>
            <LanguageSelect
              languages={languages}
              selectedLanguageAndMarket={selectedLanguageAndMarket}
              selectedCountryCode={selectedCountryCode}
            />
          </SelectWrapper>
        )} 
        {pathname !== ROUTES.home && selectedCountry && !selectedCountry.setByDefault && (
          <CountryText>
            {t('countrySelect.market', {
              countryName: t(`countrySelect.countries.${selectedCountry.name}`),
            })}
          </CountryText>
        )}
      </HeaderContent>
    </StyledHeader>
  );
};

export default AppBar;
